import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, CheckCircle, MapPin, Users } from 'lucide-react';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    service: '',
    buildingType: '',
    message: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission logic here
    alert('Enquiry submitted successfully.');
  };
  const inputClass = 'w-full bg-primary-dark/5 rounded-xl py-4 px-5 text-base text-primary-dark placeholder:text-primary-dark/40 focus:outline-none focus:bg-primary-dark/10 focus:ring-2 focus:ring-accent/50 transition-all border-none';
  return <main className="min-h-screen font-sans text-primary-dark" data-id="element-432">
      {/* Hero */}
      <section className="bg-[#E8F0F8] pt-36 pb-20" data-id="element-433">
        <div className="container mx-auto px-6" data-id="element-434">
          <div className="grid lg:grid-cols-12 gap-12 items-start" data-id="element-435">
            <div className="lg:col-span-7" data-id="element-436">
              <motion.h1 initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6
            }} className="text-4xl md:text-5xl lg:text-6xl font-serif leading-tight text-primary-dark" data-id="element-437">
                Talk to our commercial HVAC team
              </motion.h1>
            </div>
            <div className="lg:col-span-5 lg:pt-6" data-id="element-438">
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.1
            }} className="text-lg text-primary-dark/70 leading-relaxed" data-id="element-439">
                We work exclusively with commercial properties. Tell us about
                your building and we will come back to you within 4 hours.
              </motion.p>
            </div>
          </div>
        </div>
      </section>

      {/* Form & Info Section */}
      <section className="bg-white py-24" data-id="element-440">
        <div className="container mx-auto px-6" data-id="element-441">
          <div className="bg-white rounded-3xl shadow-xl border border-primary-dark/5 overflow-hidden" data-id="element-442">
            <div className="grid lg:grid-cols-5" data-id="element-443">
              {/* Left Column: Form */}
              <div className="lg:col-span-3 p-8 md:p-12 lg:p-16" data-id="element-444">
                <form onSubmit={handleSubmit} className="space-y-6" data-id="element-445">
                  <div className="grid md:grid-cols-2 gap-6" data-id="element-446">
                    <div data-id="element-447">
                      <label htmlFor="name" className="block text-sm font-medium text-primary-dark/70 mb-2.5" data-id="element-448">
                        Full name *
                      </label>
                      <input required type="text" id="name" name="name" value={formData.name} onChange={handleChange} className={inputClass} placeholder="Your name" data-id="element-449" />
                    </div>
                    <div data-id="element-450">
                      <label htmlFor="company" className="block text-sm font-medium text-primary-dark/70 mb-2.5" data-id="element-451">
                        Company name *
                      </label>
                      <input required type="text" id="company" name="company" value={formData.company} onChange={handleChange} className={inputClass} placeholder="Business name" data-id="element-452" />
                    </div>
                  </div>

                  <div className="grid md:grid-cols-2 gap-6" data-id="element-453">
                    <div data-id="element-454">
                      <label htmlFor="email" className="block text-sm font-medium text-primary-dark/70 mb-2.5" data-id="element-455">
                        Work email *
                      </label>
                      <input required type="email" id="email" name="email" value={formData.email} onChange={handleChange} className={inputClass} placeholder="you@company.co.uk" data-id="element-456" />
                    </div>
                    <div data-id="element-457">
                      <label htmlFor="phone" className="block text-sm font-medium text-primary-dark/70 mb-2.5" data-id="element-458">
                        Phone number *
                      </label>
                      <input required type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className={inputClass} placeholder="07xxx xxxxxx" data-id="element-459" />
                    </div>
                  </div>

                  <div className="grid md:grid-cols-2 gap-6" data-id="element-460">
                    <div data-id="element-461">
                      <label htmlFor="service" className="block text-sm font-medium text-primary-dark/70 mb-2.5" data-id="element-462">
                        Service needed
                      </label>
                      <select id="service" name="service" value={formData.service} onChange={handleChange} className={`${inputClass} appearance-none`} data-id="element-463">
                        <option value="" data-id="element-464">Select a service...</option>
                        <option value="Installation" data-id="element-465">Installation</option>
                        <option value="Maintenance" data-id="element-466">Maintenance</option>
                        <option value="TM44 compliance" data-id="element-467">TM44 compliance</option>
                        <option value="Ventilation" data-id="element-468">Ventilation</option>
                        <option value="FM support" data-id="element-469">FM support</option>
                        <option value="Not sure" data-id="element-470">Not sure</option>
                      </select>
                    </div>
                    <div data-id="element-471">
                      <label htmlFor="buildingType" className="block text-sm font-medium text-primary-dark/70 mb-2.5" data-id="element-472">
                        Building type
                      </label>
                      <select id="buildingType" name="buildingType" value={formData.buildingType} onChange={handleChange} className={`${inputClass} appearance-none`} data-id="element-473">
                        <option value="" data-id="element-474">Select building type...</option>
                        <option value="Office" data-id="element-475">Office</option>
                        <option value="Retail" data-id="element-476">Retail</option>
                        <option value="Hospitality" data-id="element-477">Hospitality</option>
                        <option value="Healthcare" data-id="element-478">Healthcare</option>
                        <option value="Education" data-id="element-479">Education</option>
                        <option value="Industrial" data-id="element-480">Industrial</option>
                        <option value="Other" data-id="element-481">Other</option>
                      </select>
                    </div>
                  </div>

                  <div data-id="element-482">
                    <label htmlFor="message" className="block text-sm font-medium text-primary-dark/70 mb-2.5" data-id="element-483">
                      Message
                    </label>
                    <textarea id="message" name="message" rows={4} value={formData.message} onChange={handleChange} className={`${inputClass} resize-none`} placeholder="Tell us about your requirement..." data-id="element-484"></textarea>
                  </div>

                  <button type="submit" className="w-full bg-accent hover:bg-accent/90 text-white font-medium py-4 rounded-full transition-colors mt-4" data-id="element-485">
                    Send enquiry
                  </button>
                </form>
              </div>

              {/* Right Column: Info */}
              <div className="lg:col-span-2 bg-[#F8FAFC] p-8 md:p-12 lg:p-16 border-l border-primary-dark/5" data-id="element-486">
                <div className="space-y-8" data-id="element-487">
                  <div className="flex items-center gap-4" data-id="element-488">
                    <div className="w-10 h-10 rounded-full bg-accent/10 flex items-center justify-center flex-shrink-0" data-id="element-489">
                      <Clock className="w-5 h-5 text-accent" data-id="element-490" />
                    </div>
                    <span className="font-medium text-primary-dark" data-id="element-491">
                      Typical response within 4 hours
                    </span>
                  </div>
                  <div className="flex items-center gap-4" data-id="element-492">
                    <div className="w-10 h-10 rounded-full bg-accent/10 flex items-center justify-center flex-shrink-0" data-id="element-493">
                      <CheckCircle className="w-5 h-5 text-accent" data-id="element-494" />
                    </div>
                    <span className="font-medium text-primary-dark" data-id="element-495">
                      No-obligation site survey
                    </span>
                  </div>
                  <div className="flex items-center gap-4" data-id="element-496">
                    <div className="w-10 h-10 rounded-full bg-accent/10 flex items-center justify-center flex-shrink-0" data-id="element-497">
                      <MapPin className="w-5 h-5 text-accent" data-id="element-498" />
                    </div>
                    <span className="font-medium text-primary-dark" data-id="element-499">
                      Nationwide coverage
                    </span>
                  </div>
                  <div className="flex items-center gap-4" data-id="element-500">
                    <div className="w-10 h-10 rounded-full bg-accent/10 flex items-center justify-center flex-shrink-0" data-id="element-501">
                      <Users className="w-5 h-5 text-accent" data-id="element-502" />
                    </div>
                    <span className="font-medium text-primary-dark" data-id="element-503">
                      In-house engineers only
                    </span>
                  </div>

                  <hr className="border-primary-dark/10" data-id="element-504" />

                  <div className="space-y-4 text-primary-dark/80" data-id="element-505">
                    <p data-id="element-506">
                      <strong data-id="element-507">Phone:</strong> 024 7699 8234
                    </p>
                    <p data-id="element-508">
                      <strong data-id="element-509">Email:</strong> info@accutemp.co.uk
                    </p>
                    <p data-id="element-510">
                      <strong data-id="element-511">Address:</strong> Justa House, 204-206 Holbrook
                      Lane, Coventry, CV6 4DD
                    </p>
                  </div>

                  <div className="bg-primary-dark/5 p-4 rounded-xl text-sm text-primary-dark/60 leading-relaxed" data-id="element-512">
                    We specialise in commercial properties. For residential
                    enquiries, please contact a domestic installer.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="bg-[#D4DDE8] py-20 text-center" data-id="element-513">
        <div className="container mx-auto px-6" data-id="element-514">
          <h2 className="text-2xl font-serif mb-6" data-id="element-515">Visit our headquarters</h2>
          <p className="text-primary-dark/70 mb-8" data-id="element-516">
            Justa House, 204-206 Holbrook Lane, Coventry, CV6 4DD
          </p>
          <a href="https://maps.google.com/?q=Justa+House+204-206+Holbrook+Lane+Coventry+CV6+4DD" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-white hover:bg-white/80 text-primary-dark px-6 py-3 rounded-full font-medium transition-colors shadow-sm" data-id="element-517">
            <MapPin className="w-4 h-4" data-id="element-518" />
            Find us on Google Maps
          </a>
        </div>
      </section>
    </main>;
}